import moment from 'moment';

export function getSiteDateKey(
  date: Date = new Date(),
  shiftStartTime: string,
  timezone: string
): string {
  const current = moment.tz(date, timezone);
  const [shiftHour, shiftMinute] = shiftStartTime?.split(':').map(Number);

  const shiftStartToday = current
    .clone()
    .startOf('day')
    .add(shiftHour || 0, 'hours')
    .add(shiftMinute || 0, 'minutes');

  // If we're before today's shift start, use "yesterday" as the operational day
  if (current.isBefore(shiftStartToday)) {
    current.subtract(1, 'day');
  }

  return current.format('MMDDYYYY');
}
